import * as auth from '../../app/modules/auth/redux/AuthRedux'
import {useDispatch} from 'react-redux'

export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken},
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  // Response interceptor for API calls
  axios.interceptors.response.use(
    (response: any) => {
      return response
    },
    async function (error: any) {
      const originalRequest = error.config
      if (error.response.status === 401 && !originalRequest._retry) {
        console.log('error', error)
        // originalRequest._retry = true
        // const access_token = await refreshAccessToken()
        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token
        // return axios(originalRequest)
      }
      return Promise.reject(error)
    }
  )
}
